import type { GiftCard, GiftCardSingle } from '../GiftCards.types'

export const isGiftCardSingle = (giftCard: GiftCard): giftCard is GiftCardSingle => 'id' in giftCard
